<script lang="ts">
  import { state_showContactForm } from './../../store/state';
  import { WindowsCustomEventTypes } from './../../enums/windows-custom-event.enum';
  import CardTheme from './card-theme.svelte';
  import { fade } from 'svelte/transition';
  import { _ } from 'svelte-i18n';
  import { UserHandler } from '../../controllers/handlers/user.handler';
  import { ConfigStore } from '../../store/config';

  let _userHandler = new UserHandler();

  let isValid = false;

  const hideContactWindow = () => {
    if (isValid) {
      window.dispatchEvent(
        new CustomEvent(WindowsCustomEventTypes.requestGreeting)
      );
      window.dispatchEvent(
        new CustomEvent(WindowsCustomEventTypes.toggleContactForm, {
          detail: !$state_showContactForm,
        })
      );
    }
  };

  const validateEmail = (value: string): string | null => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!value.trim || !emailRegex.test(value.trim())) {
      return $_('contact_form.email_error');
    }
    return null;
  };

  const handleValidEmail = (detail: { value: string }) => {
    _userHandler.addProperty('email_address', detail.value);
    isValid = true;
  };

  const handleInvalidEmail = () => {
    _userHandler.removeProperty('email_address');
    isValid = false;
  };
</script>

<div class="cs-contact-wrapper" out:fade|global>
  <div class="cs-contact-content">
    <CardTheme
      handleValidCard={handleValidEmail}
      handleInvalidCard={handleInvalidEmail}
      validateCard={validateEmail}
      cardTitle={$ConfigStore.contactForEmailTitle || $_('contact_form.card_email_title')}
      placeholder = {$ConfigStore.contactFormEmailPlaceholder || $_('contact_form.card_email_placeholder')}
      cardValue={_userHandler.getProperty('email_address') || ''}
    />
  </div>
  <div class="cs-contact-action">
    <button
      disabled={!isValid}
      aria-label={$ConfigStore.contactFormEmailPlaceholder || $_('contact_form.submit')}
      aria-controls={$ConfigStore.contactFormEmailPlaceholder || $_('contact_form.submit')}
      title={$ConfigStore.contactFormEmailPlaceholder || $_('contact_form.submit')}
      on:click={hideContactWindow}>{$ConfigStore.contactFormEmailPlaceholder || $_('contact_form.submit')}</button
    >
  </div>
</div>

<style lang="scss">
  @use './../../../scss/components/themes/contact-window';
</style>
